import classNames from 'classnames'
import { DataModel } from 'legacy/lut/classes/models/DataModel'
import { IBusinessProfileIcon } from 'legacy/lut/classes/services/api/BusinessProfileApi'
import { PhoneCall } from 'legacy/lut/components/shared/PhoneCall'
import React from 'react'

import { IForm } from 'core-components/classes/models/IForm'
import { Tooltip } from 'core-components/library/tooltip'
import { getFormatDate } from 'core/classes/helpers/DateHelper'
import { TUser } from 'core/classes/models/User'

import { BPRegistrationPopup } from './BPRegistrationPopup'
import RenderCardHead from './RenderCardHead'
import { getCompetitors, getIcon, getPhone, getWorkflowStatusColor } from './tileBlocksMethods'

import styles from './summaryBlock.module.scss'

interface IProps {
  item: DataModel | IForm
  relationship: IBusinessProfileIcon[]
  changeMindset: IBusinessProfileIcon[]
  roles: IBusinessProfileIcon[]
  status: IBusinessProfileIcon[]
  user: TUser
}

export default function summaryBlock(props: IProps) {
  const { item, relationship, changeMindset, roles, status } = props

  const relationShipIcon = getIcon(relationship, item.get('RelationshipStrength') || '')
  const changeMindsetIcon = getIcon(changeMindset, item.get('ChangeMindset') || '')
  const roleIcon = getIcon(roles, item.get('Role') || '')
  const statusIcon = getIcon(status, item.get('ContactStatus') || '')

  return (
    <div className={styles.root}>
      <div className={classNames(styles.root__side, styles.side)}>
        <div
          className={styles.side__status}
          style={{
            backgroundColor: getWorkflowStatusColor(item.get('WorkflowStatus') || ''),
          }}
        />
        <div className={styles.side__body}>
          {item.get('Photo') ? (
            <div className={styles.avatar}>
              <img className={styles.avatar__img} src={item.get('Photo')} alt={'avatar'} />
            </div>
          ) : null}
          {item.get('PreferredContact') && (
            <i
              className={classNames(
                'hpicon hpicon-star',
                item.get('Photo') ? styles.avatarIcon : styles.avatarNoPhoto
              )}
            />
          )}
          <div className={classNames(styles.icons, styles['icons--center'])}>
            <a
              href={item.get('LinkedInLink') || undefined}
              target="_blank"
              rel="noopener noreferrer"
              className={classNames(styles.icons__item, 'hpicon hpicon-social-linkedin')}
              style={{
                color: item.get('LinkedInLink') ? '#4875B4' : '#ccc',
              }}
              title="LinkedIn"
            />
            <a
              href={item.get('FacebookLink') || undefined}
              target="_blank"
              rel="noopener noreferrer"
              className={classNames(styles.icons__item, 'hpicon hpicon-social-facebook')}
              style={{
                color: item.get('FacebookLink') ? '#3B5998' : '#ccc',
              }}
              title="Facebook"
            />
            <a
              href={item.get('TwitterLink') || undefined}
              target="_blank"
              rel="noopener noreferrer"
              className={classNames(styles.icons__item, 'hpicon hpicon-social-twitter')}
              style={{
                color: item.get('TwitterLink') ? '#33CCFF' : '#ccc',
              }}
              title="Twitter"
            />
            <a
              href={item.get('WhatsAppLink') || undefined}
              target="_blank"
              rel="noopener noreferrer"
              className={classNames(styles.icons__item, 'hpicon hpicon-mindset-none')}
              style={{
                color: item.get('WhatsAppLink') ? '#25D366' : '#ccc',
              }}
              title="WhatsApp"
            />
          </div>
        </div>
      </div>

      <div className={classNames(styles.root__body, styles.body)}>
        <header className={styles.header}>
          <div className={styles.header__title}>
            <Tooltip tipContent={() => <>{`${item.get('FirstName')} ${item.get('LastName')}`}</>}>
              <p className={styles.profileName}>
                <span className={styles.profileName__item}>
                  {item.get('Salutation')} {item.get('FirstName')}
                </span>
                <span className={styles.profileName__item}>{item.get('LastName')}</span>
                {!item.get('Status') && <i className={'kbase-lvl-eye-off'} />}
              </p>
            </Tooltip>
            <p className={styles.profileSeniority}>{item.get('Seniority') || '\u00A0'}</p>
          </div>
          <RenderCardHead item={item} />
        </header>

        <div className={styles.icons}>
          <div className={styles.icons__item}>
            {item.get('NeverEmail') ? (
              item.get('NeverEmail') === 'Y' ? (
                <Tooltip tipContent={() => <>Email flag</>}>
                  <i
                    className="hpicon hpicon-envelope"
                    style={{
                      color: '#ea4463',
                      fontSize: '19px',
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip tipContent={() => <>Email flag</>}>
                  <a href={`mailto:${item.get('Email')}`}>
                    <i
                      className="hpicon hpicon-envelope"
                      style={{
                        color: '#008424',
                        fontSize: '19px',
                      }}
                    />
                  </a>
                </Tooltip>
              )
            ) : (
              <Tooltip tipContent={() => <>Email flag</>}>
                <i
                  className="hpicon hpicon-envelope"
                  style={{
                    color: '#cccccc',
                    fontSize: '19px',
                  }}
                />
              </Tooltip>
            )}
          </div>
          <div className={styles.icons__item}>
            {item.get('NeverCall') ? (
              item.get('NeverCall') === 'Y' ? (
                <Tooltip tipContent={() => <>Phone flag</>}>
                  <i
                    className="hpicon hpicon-telephone2"
                    style={{
                      color: '#ea4463',
                      fontSize: '19px',
                    }}
                  />
                </Tooltip>
              ) : (
                <Tooltip tipContent={() => <>Phone flag</>}>
                  <PhoneCall
                    value={getPhone(item)}
                    isContactLevel={!!item.get('HPD_Contact_GUID')}
                    guid={item.get('HPD_Contact_GUID') || item.get('HPD_Partner_GUID')}
                    icon={
                      <i
                        className="hpicon hpicon-telephone2"
                        style={{
                          color: '#008424',
                          fontSize: '19px',
                        }}
                      />
                    }
                    partnerId={item.get('PartnerID')}
                  />
                </Tooltip>
              )
            ) : (
              <Tooltip tipContent={() => <>Phone flag</>}>
                <i
                  className="hpicon hpicon-telephone2"
                  style={{
                    color: '#cccccc',
                    fontSize: '19px',
                  }}
                />
              </Tooltip>
            )}
          </div>
          <div className={styles.icons__item}>
            <Tooltip tipContent={() => <>BP Registration</>}>
              <BPRegistrationPopup
                partnerId={item.get('PartnerID')}
                communicationName={item.get('CommunicationName')}
                contactId={item.get('ContactID')}
                contactEmail={item.get('Email')}
                country={item.get('Country')}
              />
            </Tooltip>
          </div>
          <div className={styles.icons__item}>
            <Tooltip tipContent={() => <>Saba Access</>}>
              <i
                className="hpicon hpicon-saba"
                style={{
                  color: item.get('IsSabaUser') ? '#008424' : '#cccccc',
                  fontSize: '19px',
                }}
              />
            </Tooltip>
          </div>
          <div className={styles.icons__item}>
            <Tooltip tipContent={() => <>PPA Status</>}>
              <i
                className="hpicon hpicon-ppa"
                style={{
                  color: item.get('IsPPA') ? '#008424' : '#cccccc',
                  fontSize: '19px',
                }}
              />
            </Tooltip>
          </div>
        </div>

        <div className={styles.icons}>
          {relationShipIcon ? (
            <div className={styles.icons__item}>
              <Tooltip tipContent={() => <>Relationship Strength</>}>
                <i
                  className={relationShipIcon.Class}
                  style={{
                    color: relationShipIcon.Color,
                    fontSize: '40px',
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
          {changeMindsetIcon ? (
            <div className={styles.icons__item}>
              <Tooltip tipContent={() => <>Change Mindset</>}>
                <i
                  className={changeMindsetIcon.Class}
                  style={{
                    color: changeMindsetIcon.Color,
                    fontSize: '40px',
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
          {roleIcon ? (
            <div className={styles.icons__item}>
              <Tooltip tipContent={() => <>Role</>}>
                <i
                  className={roleIcon.Class}
                  style={{
                    color: roleIcon.Color,
                    fontSize: '40px',
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
          {statusIcon ? (
            <div className={styles.icons__item}>
              <Tooltip tipContent={() => <>Contact Status</>}>
                <i
                  className={statusIcon.Class}
                  style={{
                    color: statusIcon.Color,
                    fontSize: '40px',
                  }}
                />
              </Tooltip>
            </div>
          ) : null}
          <div className={styles.icons__item}>
            <Tooltip tipContent={() => <>HP Hero</>}>
              <i
                className="hpicon hpicon-contact-hero"
                style={{
                  color: item.get('HPHero') ? '#0e93d2' : '#cccccc',
                  fontSize: '18px',
                  marginBottom: '3px',
                }}
              />
            </Tooltip>
            <Tooltip tipContent={() => <>{getCompetitors(item)}</>}>
              <i
                className="hpicon hpicon-swords"
                style={{
                  color: JSON.parse(item.get('Competitors') || '[]').length ? '#ea4463' : '#cccccc',
                  fontSize: '18px',
                  display: 'flex',
                  marginLeft: 0,
                }}
              />
            </Tooltip>
          </div>
        </div>

        <div className={styles.lastContacted}>
          <p className={styles.lastContacted__text}>
            Last contacted:{' '}
            {item.get('Last_Call_Date') ? getFormatDate(item.get('Last_Call_Date'), 'date') : '-'}
          </p>
        </div>
      </div>
    </div>
  )
}
